import { Container, Stack, SvgIcon } from "@mui/material";
import React, { useContext, useState } from "react";
import CryptoJS from "crypto-js";
import "@fontsource/manrope";
import "@fontsource/manrope/400.css";
import { String } from "../../constants/Strings";
import ACRButton from "../../commanComponents/ACRButton";
import { OTPScreen } from "./OTPScreen";

import {
  StyledACRButton,
  StyledBottomBox,
  StyledBottomText,
} from "../../style/styleComponents/StyledOnboarding";
import CustomSnackbar from "../../commanComponents/CustomerSnackbar";
import useOnboardingOTP from "../../Hooks/CustomHooks/useOnboardingOTP";
import { AgentContext } from "../../Hooks/context/AgentData";
import { useLocation, useNavigate } from "react-router-dom";
import { OTPVerifyContext } from "../../Hooks/context/OTPVeriryContext";
import SlideShow from "./Slideshow";
import { getColor } from "../../style/color/color";
import { gaCustomEvent } from "../../logic/CommonFunctions";

const  Onbording = () => {
  const [open, setOpen] = useState(false);
  const [openValidationSnackbar, setOpenValidationSnackbar] = useState(false);
  const [securedMobileNUmber, setSecuredMobileNumber] = useState("");
  const { agentCollectData } = useContext(AgentContext);
  const navigation = useNavigate();
  const {
    otp,
    setOtp,
    errors,
    openSnackbar,
    setOpenSnackbar,
    snackbarOTPEnter,
    setSnackbarOTPEnter,
    messageSet,
    handleOTPChange,
    handleSendOTP,
    handleAuthorize,
    timer,
    setTimer,
    startTimer,
  } = useOnboardingOTP();

  const SECRET_KEY = CryptoJS.enc.Utf8.parse("1234567890123456"); // 16-byte key
  const IV = CryptoJS.enc.Utf8.parse("abcdefghijklmnop");

  const { collectData } = useContext(OTPVerifyContext);
  let location = useLocation();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const decryptData = (encryptedData) => {
    try {
      if (!encryptedData)
        throw new Error(String.OnbordingStr.noDecryptedErrorMessage);

      // Decode Base64 encoded string
      const decodedData = CryptoJS.enc.Base64.parse(encryptedData);

      // Decrypt the data using AES
      const decrypted = CryptoJS.AES.decrypt(
        { ciphertext: decodedData },
        SECRET_KEY,
        {
          iv: IV,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        }
      );

      // Convert decrypted data to UTF-8 string
      const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
      if (!decryptedText)
        throw new Error(String.OnbordingStr.DecryptedErrorMessage);

      // Parse the JSON string if applicable
      return JSON.parse(decryptedText);
    } catch (error) {
      return null;
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  //This method contains decrpytion for encoded string and naviagate to agent dashboard if agentflag true or send otp to consumer for jounery
  const handleClickOpen = async () => {
    setOpenValidationSnackbar(false);

    const res = decryptData(location.search.match(/data=(.+)/)[1]);
    collectData(res);
    gaCustomEvent(String.gaEventName.acrLogin, String.gaEventClickName.acrLoginLetsBegin, res.customerId);
    if (res.agentFlag) {
      agentCollectData(res);
      navigation(String.navigations.dashboard);
    }
    const { phoneNumber } = res;

    setSecuredMobileNumber(
      phoneNumber.slice(0, 2) + phoneNumber.slice(2).replace(/.(?=...)/g, "*")
    );

    const data = {
      userId: res.customerId,
    };

    const success = await handleSendOTP(data);
    if (success) {
      setOpen(true);
      startTimer();
    }
  };

  return (
    <Container>
      <Stack
        sx={{
          justifyContent: "center",
          alignItems: "center",
          mt: { xs: "28%", md: "30%" },
          textAlign: "center",
        }}
      >
        {/* this component open images with automatically sliding */}
        <SlideShow />

        <ACRButton
          label={String.OnbordingStr.ButtonName}
          style={StyledACRButton}
          onClickButton={handleClickOpen}
        />
        {/* This component open otp input feilds  */}
        <OTPScreen
          openDialog={open}
          otp={otp}
          setOtp={setOtp}
          handleClose={handleClose}
          onOTPHandleChange={handleOTPChange}
          handleAuthorize={handleAuthorize}
          OpenSnackbar={openSnackbar}
          setOpenopenSnackbar={setOpenSnackbar}
          title={String.OTPScreen.Title}
          snackbarOTPEnter={snackbarOTPEnter}
          setSnackbarOTPEnter={setSnackbarOTPEnter}
          message={messageSet.message}
          error={errors.error}
          timer={timer}
          setTimer={setTimer}
          startTimer={startTimer}
          securedMobileNumber={securedMobileNUmber}
        ></OTPScreen>

        <StyledBottomBox>
          <SvgIcon>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              color={getColor.SecondaryIrishGreen}
            >
              <path
                d="M10 18.7496C9.92075 18.7508 9.84209 18.7359 9.76875 18.7059C9.49375 18.5934 3.125 15.9996 3.125 11.8746V4.37463C3.12488 4.24945 3.16235 4.12713 3.23255 4.02349C3.30275 3.91986 3.40246 3.83969 3.51875 3.79338L9.875 1.29338C10.0235 1.23424 10.189 1.23424 10.3375 1.29338L16.4875 3.79338C16.6026 3.84067 16.701 3.92126 16.77 4.02481C16.8391 4.12837 16.8756 4.25017 16.875 4.37463V11.8746C16.875 15.9996 10.5062 18.5934 10.2312 18.7059C10.1579 18.7359 10.0792 18.7508 10 18.7496ZM4.375 4.79963V11.8746C4.375 14.4809 8.23125 16.6871 10 17.4496C11.0875 16.9684 15.625 14.7809 15.625 11.8746V4.79338L10.1 2.54963L4.375 4.79963ZM9.775 11.7309L13.525 8.60588L12.725 7.64338L9.375 10.4559L7.25 8.87463L6.5 9.87463L9 11.7496C9.10818 11.8308 9.23977 11.8746 9.375 11.8746C9.52103 11.8749 9.66255 11.8241 9.775 11.7309Z"
                fill="#099A4F"
              />
            </svg>
          </SvgIcon>
          <StyledBottomText variant="body2">
            {String.OnbordingStr.badgeText}
          </StyledBottomText>
        </StyledBottomBox>
        <CustomSnackbar
          open={openValidationSnackbar}
          handleClose={() => {
            setOpenValidationSnackbar(false);
          }}
          message={errors.invalid || errors.server}
          severity={String.ErrorSeverity}
        />
      </Stack>
    </Container>
  );
};

export default Onbording;
